export default "__VITE_ASSET__88c887ed__"